<template>
	<div class="page pageContainer">
		<div class="nav">
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item>基础数据</el-breadcrumb-item>
				<el-breadcrumb-item>数据统计表</el-breadcrumb-item>

			</el-breadcrumb>

		</div>

		<el-tabs v-model="activeName" type="card" style="">
			
			<el-tab-pane label="联院质量表" name="table4"></el-tab-pane>
			
			

		</el-tabs>
		<div>
			
			<stu_qulity  v-if="activeName=='table4'"></stu_qulity>
		</div>

	</div>
</template>

<script>
	
	import  stu_qulity from './xlstable/stu_qulity.vue'
	export default {
		components: {stu_qulity},
		data() {
			return {
				activeName: "table4"
			}
		},
		mounted() {

		},
		methods: {},
	}
</script>

<style>
</style>
